import { render, staticRenderFns } from "./Colors.vue?vue&type=template&id=3be4cc83"
import script from "./Colors.vue?vue&type=script&lang=js"
export * from "./Colors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3be4cc83')) {
      api.createRecord('3be4cc83', component.options)
    } else {
      api.reload('3be4cc83', component.options)
    }
    module.hot.accept("./Colors.vue?vue&type=template&id=3be4cc83", function () {
      api.rerender('3be4cc83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/dialog/Colors.vue"
export default component.exports